<div class="player-row" style="border-bottom: 1px #56565677 solid; padding: 3px 0; ">
  <mat-grid-list cols="5"  rowHeight="fit" style="height: 100%; display: none;">
    <!-- Jersey Number -->
    <mat-grid-tile [colspan]="1" [rowspan]="1" (click)="navigate($event,this.Player.LifelineScoutingId);">
      <div class="jersey-number">{{this.Player.PlayerView.JerseyNo}}</div>
    </mat-grid-tile>

    <!-- Player Name -->
    <mat-grid-tile [colspan]="3" [rowspan]="1" (click)="navigate($event,this.Player.LifelineScoutingId);" matRipple matRippleColor="#ffe0b24d">
      <div class="full-width" >
        <div style="font-size: 12px;">{{this.Player.PlayerView.LastName}},{{this.Player.PlayerView.FirstName}}</div>
      </div>
    </mat-grid-tile>

    <!-- Tags -->
    <mat-grid-tile [colspan]="1" [rowspan]="1">
      <div class="full-width">
        @for (tag of this.Player.Tags; track tag.TagId) {
          <div [ngClass]="tag.TagColor">
            {{tag.TagText}}
          </div>
        }
      </div>
    </mat-grid-tile>

    <!-- Favorite Star -->
    <mat-grid-tile [colspan]="1" [rowspan]="1">
      @if (this.Player.IsFavourite) {
        <mat-icon style="color: orange;">star</mat-icon>
      }
    </mat-grid-tile>

    <!-- Report/Note Counts -->
    @if (this.Player.PlayerView.ReportCount>0 || this.Player.PlayerView.NoteCount>0) {
      <mat-grid-tile [colspan]="2" [rowspan]="1">
        <div class="full-width">
          <mat-icon style="font-size: 24px;vertical-align: bottom;">rate_review</mat-icon>&nbsp;<b>{{this.Player.PlayerView.ReportCount}}</b>&nbsp;
          @if (this.Player.PlayerView.NoteCount>0) {
            <span>
              <mat-icon style="font-size: 24px;vertical-align: bottom;">insert_comment</mat-icon>&nbsp;
              <b>{{this.Player.PlayerView.NoteCount}}</b>
            </span>
          }
        </div>
      </mat-grid-tile>
    }
    @if (this.Player.ReportCount==0 && this.Player.NoteCount==0) {
      <mat-grid-tile [colspan]="2" [rowspan]="1"></mat-grid-tile>
    }

    <!-- Flag -->
<!--     <mat-grid-tile [colspan]="1" [rowspan]="1">
      <div class="full-width text-right">
        <img style="height: 20px;" src="../../assets/img/SWE.png" />
      </div>
    </mat-grid-tile> -->

    <!-- Player Details -->
    <mat-grid-tile [colspan]="4" [rowspan]="1">
      <div class="full-width">
        <span class="player-details">{{this.Player.PlayerView.DateOfBirth | date:'yyy-MM-dd'}} - {{this.Player.PlayerView.Height}} cm - {{this.Player.PlayerView.Weight}} kg</span>
      </div>
    </mat-grid-tile>

    <!-- Menu Button -->
    <mat-grid-tile [colspan]="1" [rowspan]="1">
      <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Player menu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item [routerLink]="['/scouting/newreport', this.Player.LifelineScoutingId, this.GameId]">
          <mat-icon>rate_review</mat-icon>
          <span>New report</span>
        </button>
        <button mat-menu-item [routerLink]="['/scouting/newnote', this.Player.LifelineScoutingId, this.GameId]">
          <mat-icon>insert_comment</mat-icon>
          <span>New note</span>
        </button>
         <button mat-menu-item (click)="openSelectRankingListDialog()">
          <mat-icon>format_list_numbered</mat-icon>
          <span>Add to list</span>
        </button>
      </mat-menu>
    </mat-grid-tile>
  </mat-grid-list>
  <table class="player-row-table">
    <tr>
      <td style="width: 20px; vertical-align: top; font-weight: bold;">
        {{this.Player.PlayerView.JerseyNo}}
          @if (this.Player.IsFavourite) {
            <mat-icon style="color: orange; font-size: medium; height: 24px;">star</mat-icon>
          }
      </td>
      <td colspan="4" class="player-main-cell" (click)="navigate($event,this.Player.LifelineScoutingId);">
        <div class="player-name-line">
          {{this.Player.PlayerView.LastName}}, {{this.Player.PlayerView.FirstName}}

        </div>
        <div class="player-meta-line">

          <img [src]="('/assets/img/' + this.Player.PlayerView.Nationality + '.png').replace('//','/').toLowerCase()" style="height: 16px;">
          -
          {{this.Player.PlayerView.DateOfBirth | date: 'yyyy-MM-dd'}} - {{this.Player.PlayerView.Height}} cm&nbsp;-&nbsp;{{this.Player.PlayerView.Weight}} kg
        </div>

        @if (this.Player.PlayerView.ReportCount+this.Player.PlayerView.NoteCount>0) {
          <div class="report-note-count">
            <mat-icon style="font-size: 18px;">rate_review</mat-icon>
            {{this.Player.PlayerView.ReportCount}}
            &nbsp;
            <mat-icon style="vertical-align: bottom;font-size: 18px;">insert_comment</mat-icon>
            {{this.Player.PlayerView.NoteCount}}
          </div>
        }


      </td>
      <td class="player-menu-cell">
        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Player menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item [routerLink]="['/scouting/newreport', this.Player.LifelineScoutingId, this.GameId]">
            <mat-icon>rate_review</mat-icon>
            <span>New report</span>
          </button>
          <button mat-menu-item [routerLink]="['/scouting/newnote', this.Player.LifelineScoutingId, this.GameId]">
            <mat-icon>insert_comment</mat-icon>
            <span>New note2</span>
          </button>
          <button mat-menu-item (click)="openSelectRankingListDialog()">
            <mat-icon>format_list_numbered</mat-icon>
            <span>Add to list</span>
          </button>
        </mat-menu>
      </td>
    </tr>
  </table>
</div>

<style>
  .player-row {
  width: 100%;
}
  .player-row-table {
    width: 100%;
    max-width: 100%;
    table-layout: fixed;
  }
  .player-main-cell {
    vertical-align: top;
    overflow: hidden;
  }
  .player-name-line {
    vertical-align: top;
    margin-right: 3px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .player-meta-line {
    color: gray;
    font-size: small;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .report-note-count {
    display: flex;
    align-items: center;
    min-width: 70px;
    font-size: x-small;
  }
  .player-menu-cell {
    width: 40px;
    text-align: right;
    vertical-align: top;
    white-space: nowrap;
  }
.jersey-number {
font-size: 20px;
width: 100%;
text-align: center;
}
.player-name {
font-size: 15px;
overflow:visible;
}
.player-details {
font-size: 10px;
}
.full-width {
width: 100%;
height: 100%;
display: flex;
align-items: center;
}
.text-right {
justify-content: flex-end;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
.mat-grid-tile {
box-sizing: border-box !important;
}
.jersey-number, .player-name, .player-details {
font-size: 12px;
}
.full-width {
flex-direction: column;
align-items: flex-start;
}
.player-meta-line {
font-size: x-small;
}
}
</style>